<div class="order-salon">
  <div class="box">
    <div class="main">
      <div class="tablegroup">
        <div
          class="saloncard"
          *ngFor="let salon of salonOrder._salons"
          (click)="salonOrder.getTablesRead(salon)"
          [class.selecteditem]="salon?.Id === salonOrder.selectedSalons?.Id">
          <span class="number">{{ salon.Title }}</span>
        </div>
        <button class="refresh-btn" (click)="refreshTables()">
          <i class="icon-refresh-o"></i>
        </button>
      </div>
      <div class="state">
        <div class="d-flex">
          <ul class="tablestate" *ngFor="let item of salonOrder.tableFilter; trackBy: salonOrder.trackByFn">
            <li
              class="statename d-flex align-items-center"
              [ngClass]="{
                freeStatus: item.key === 1,
                orderingStatus: item.key === 2,
                clearingStatus: item.key === 3,
                timeOverStatus: item.key === 4
              }"
              (click)="item.selected = !item.selected; salonOrder.tableFilterByStatus()">
              <div class="colorstate"></div>
              <div [class.statusClickedBg]="item.selected" class="status-title">{{ item.title }} {{ item.count }}</div>
            </li>
          </ul>
        </div>
        <div class="toggle">
          <button class="togglebtn" (click)="changeTableSize()">
            <i class="icon-view_module-f" [class.icon-apps-o]="salonOrder._changeTable"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="boxcard">
    <div *ngIf="salonOrder._tempTableReads" class="cardgroup" [ngClass]="{ smallbox: !salonOrder._changeTable }">
      <div class="tableItemDiv salonbox" *ngFor="let table of salonOrder._tempTableReads">
        <div
          class="carditem"
          [tooltip]="table.SaleMethodTitle"
          [display]="table.Locked"
          (click)="salonOrder.SelectTable(table)"
          [ngClass]="{ lockedTable: table.Locked, smallbox: !salonOrder._changeTable }">
          <div class="title">
            <div class="title-header">
              <span class="number">{{ table.Title }}</span>
              <span class="questnumber">{{ table.NumberOfGuests }} {{ "ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Guest" | translate }} </span>
            </div>
            <div
              class="time"
              *ngIf="table.Status !== 1"
              [ngClass]="{
                'blue-title': table.Status === salonOrder._tableStatus.Ordering,
                'green-title': table.Status === salonOrder._tableStatus.Clearing,
                'red-title': table.Status === salonOrder._tableStatus.TimeOver
              }">
              {{ table.RelativeInvoiceTimeString }}
            </div>
            <div
              class="time"
              *ngIf="table.Status === 1"
              [ngClass]="{
                'gray-title': table.Status === salonOrder._tableStatus.Free,
                'blue-title': table.Status === salonOrder._tableStatus.Ordering,
                'green-title': table.Status === salonOrder._tableStatus.Clearing,
                'red-title': table.Status === salonOrder._tableStatus.TimeOver
              }">
              -- : --
            </div>
            <div class="footer">
              <div>
                <span class="guest-name">{{ table.CustomerName }}</span>
              </div>
              <div class="d-flex align-items-center">
                <ssg-menu
                  [name]="table.Id"
                  *ngIf="table.InvoiceId && !table.Locked"
                  icon="icon-more_vert-o"
                  class="ssgmenu"
                  (click)="$event.stopPropagation()">
                  <ng-container class="menuitem">
                    <div (click)="updateActivityPageStatus(); salonOrder.CustomerPrintInvoice(table)" class="titlemenu">
                      <button>
                        <i class="icon-print-o moreicon fonticon"></i
                        ><span> {{ "ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Print" | translate }}</span>
                      </button>
                    </div>
                    <div (click)="updateActivityPageStatus(); salonOrder.ClearingInvoice(table)" class="titlemenu">
                      <button>
                        <i class="icon-check-o moreicon fonticon"></i
                        ><span> {{ "ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Clear" | translate }}</span>
                      </button>
                    </div>
                    <div
                      (click)="updateActivityPageStatus(); salonOrder.retryLink(table)"
                      class="titlemenu"
                      *ngIf="salonOrder.order.saleMethodBranch?.IsPaymentLink && salonOrder.order.currentInformation?.PaymentPanelAVA">
                      <button>
                        <i class="icon-check-o moreicon fonticon"></i
                        ><span> {{ "ClientApp.FrontOffice.Order.OrderPage.SalonOrder.LinkPayment" | translate }}</span>
                      </button>
                    </div>
                  </ng-container>
                </ssg-menu>
                <div
                  class="colorcard"
                  [ngClass]="{
                    gray: table.Status === salonOrder._tableStatus.Free,
                    blue: table.Status === salonOrder._tableStatus.Ordering,
                    green: table.Status === salonOrder._tableStatus.Clearing,
                    red: table.Status === salonOrder._tableStatus.TimeOver
                  }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
